// src/pages/partner/PartnerDashboard.tsx
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { usePartnerDetails } from '@/hooks/usePartnerDetails';
import { Toaster } from '../../components/ui/sonner.tsx';

// Import partner components
import PartnerOverview from '@/components/partner/PartnerOverview';
import SubAccountsManager from '@/components/partner/SubAccountsManager';
import CommissionTracker from '@/components/partner/CommissionTracker';
import DomainManager from '@/components/partner/DomainManager';
import CustomPricing from '@/components/partner/CustomPricing';
import BrandingCustomizer from '@/components/partner/BrandingCustomizer';
import CoBrandedSubscriptions from '@/components/partner/CoBrandedSubscriptions';
import HelpCenterManager from '@/components/partner/HelpCenterManager';
import TutorialsTab from '@/components/partner/TutorialsTab';
// import PartnerSettings from '@/components/partner/PartnerSettings';
// Import payouts page
import Payouts from '@/components/partner/Payouts';

export default function PartnerDashboard() {
  const { profile } = useAuth();
  const { data: partnerDetails } = usePartnerDetails();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop(); // Get the last part of the path

  // Create partner data object from real profile and partner details
  const partnerData = {
    user_type: partnerDetails?.partner_type,
    partner_type: partnerDetails?.partner_type,
    subscription_plan_identifier: partnerDetails?.partner_plan || 'Standard',
    created_at: profile?.created_at_profile,
    email: profile?.email,
    full_name: profile?.full_name,
    branding_settings: partnerDetails?.branding_settings,
  };

  // Check if partner is white-label for feature access
  const isWhiteLabel = partnerDetails?.partner_type === 'white_label';

  // Render different components based on current route
  const renderContent = () => {
    switch (currentPath) {
      case 'dashboard':
        return <PartnerOverview partner={partnerData} />;
      case 'sub-accounts':
        return <SubAccountsManager/>;
      case 'commissions':
        return <CommissionTracker partner={partnerData} />;
      case 'payouts':
        return <Payouts />;
      case 'domains':
        // White-label only feature
        if (!isWhiteLabel) {
          return <div className="p-8 text-center">
            <h2 className="text-xl font-semibold mb-2">White-Label Feature</h2>
            <p className="text-muted-foreground">Domain management is only available for white-label partners.</p>
          </div>;
        }
        return <DomainManager />;
      case 'pricing':
        // White-label only feature
        if (!isWhiteLabel) {
          return <CoBrandedSubscriptions />;
        }
        return <CustomPricing />;
      case 'branding':
         // White-label only feature
         if (!isWhiteLabel) {
           return <div className="p-8 text-center">
             <h2 className="text-xl font-semibold mb-2">White-Label Feature</h2>
             <p className="text-muted-foreground">Branding customization is only available for white-label partners.</p>
           </div>;
         }
         return <BrandingCustomizer />;
       case 'help-center':
         // White-label only feature
         if (!isWhiteLabel) {
           return <div className="p-8 text-center">
             <h2 className="text-xl font-semibold mb-2">White-Label Feature</h2>
             <p className="text-muted-foreground">Help center customization is only available for white-label partners.</p>
           </div>;
         }
         return <HelpCenterManager />;
       case 'tutorials':
         return <TutorialsTab />;
       // case 'settings':
       //   return <PartnerSettings partner={partnerData} />;
       default:
         return <PartnerOverview partner={partnerData} />;
    }
  };

  return (
    <div>
      <div className="container ml-0">
        {renderContent()}
      </div>
      <Toaster richColors position="top-right" />
    </div>
  );
}